<template>
  <div>
    <el-row :gutter="20" style="margin: 0">
      <el-col :span="12">
        <el-card class="box-card">
          <div id="myChart" style="width: 100%; height: 350px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div id="browser" style="width: 100%; height: 350px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin: 0px; margin-top: 10px">
      <el-col :span="12">
        <el-card class="box-card">
          <p class="title">最新留言</p>
          <div style="width: 100%; height: 350px" class="message">
            <vue-seamless-scroll
              :data="messageList"
              :class-option="defaultOption"
            >
              <el-alert
                v-for="(item, index) in messageList"
                :key="index"
                :title="item.name"
                type="info"
                :description="item.content"
                :closable="false"
              >
              </el-alert>
            </vue-seamless-scroll>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <p class="title">系统信息</p>
          <div style="width: 100%; height: 350px" class="message">
            <vue-seamless-scroll
              :data="messageListp"
              :class-option="defaultOption"
            >
              <el-alert
                v-for="(item, index) in messageListp"
                :key="index"
                :title="item.title"
                type="info"
                :description="item.content"
                :closable="false"
              >
              </el-alert>
            </vue-seamless-scroll>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import qs from 'qs'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      account: '',
      list: [],
      visits: [],
      chartData: {
        columns: [],
        rows: []
      },
      messageList: [],
      messageListp: []
    }
  },
  computed: {
    defaultOption () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
      }
    }

  },
  created () {
    // this.getEchart()
    this.getData()
    this.getmessage()
    this.getsystom()
  },
  mounted () {
    this.drawLine()
    this.getBrowser()
  },
  methods: {
    getData () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/statistics/index',
        params: {}
      }).then((res) => {
        if (res.data.status == 200) {
          this.list = res.data.data.contentCount
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: '日访问量'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: ['0.6', '0.9', '0.1', '0.4', '0.6', '0.2', '0.7'],
          type: 'line',
          smooth: true,
          lineStyle: { // 线条的相关设置
            normal: {
              color:
                new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  // {
                  // 	offset: 0,
                  // 	color: '#E78CA4'
                  // },
                  {
                    offset: 0.8,
                    color: '#88C2FA'
                  }
                ]) // 线条颜色
            }
          }
        }]
      })
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/statistics/visit',
        params: {

        }
      }).then((res) => {
        if (res.data.status === 200) {
          var region = []
          for (var i = 0; i < res.data.data.dayVisit.length; i++) {
            region.push(res.data.data.dayVisit[i].addTime)
          }
          var number = []
          for (var i = 0; i < res.data.data.dayVisit.length; i++) {
            number.push(res.data.data.dayVisit[i].number)
          }
          myChart.setOption({
            xAxis: {
              data: region
            },
            series: {
              data: number
            }
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },

    // 浏览器来源
    async getBrowser () {
      // 基于准备好的dom，初始化echarts实例
      let myBrowser = this.$echarts.init(document.getElementById('browser'))
      // 绘制图表
      myBrowser.setOption({
        title: {
          text: '小程序访问统计'
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: '直接访问',
          type: 'bar',
          barWidth: '60%',
          data: [],
          itemStyle: {
            // 通常情况下：
            normal: {
              // 每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
              color: function (params) {
                var colorList = [
                  '#5EB6F9'
                ] // 每根柱子的颜色
                return colorList[params.dataIndex]
              }
            }

          }
        }]
      })
      const res = await this.$http({
        method: 'get',
        url: '/api/v1/statistics/index/mini',
        params: {}
      })
      console.log('访问来源1', res)
      if (res.data.status === 200) {
        var regions = []
        for (var i = 0; i < res.data.data.miniVisit.length; i++) {
          regions.push(res.data.data.miniVisit[i].mini)
        }
        var numbers = []
        for (var i = 0; i < res.data.data.miniVisit.length; i++) {
          numbers.push(res.data.data.miniVisit[i].number)
        }
        myBrowser.setOption({
          xAxis: {
            data: regions
          },
          series: {
            data: numbers
          }
        })
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 获取小程序的接口
    // 最新留言的接口
    async getmessage () {
      const res = await this.$http({
        method: 'get',
        url: '/api/v1/message/index'
      })
      console.log('这个是留言=>', res.data.data)
      this.messageList = res.data.data
    },
    // 获取系统信息的接口
    async getsystom () {
      const res = await this.$http({
        method: 'get',
        url: '/api/v1/message/index/news'
      })
      console.log('这个是系统信息=>', res.data.data)
      this.messageListp = res.data.data
    }
  }
}
</script>

<style scoped="scoped">
/deep/ .el-row {
  margin: 0;
}

.cardTitle {
  margin-bottom: 20px;
}

.cardChildren {
  width: 100%;
  height: 150px;
  margin-bottom: 20px;
}

.ChildrenOne {
  background: #8896ec;
  border-radius: 5px;
}

.ChildrenTwo {
  background: #b492e8;
  border-radius: 5px;
}

.ChildrenThree {
  background: #f3ac9c;
  border-radius: 5px;
}

.ChildrenFour {
  background: #94c2f3;
  border-radius: 5px;
}

.childrenTitle {
  width: 100%;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  letter-spacing: 2px;
  padding: 23px 0 0 20px;
}

.childrenTotal {
  width: 100%;
  height: 70px;
  font-size: 80px;
  font-family: HYBeiKeHeiW;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  display: block;
  text-align: center;
  margin-top: 30px;
}

.childSystem {
  text-align: right;
  color: #ffffff;
  font-size: 22px;
  margin-right: 10px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.message {
  overflow: hidden;
}
.message /deep/ .el-alert {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue